import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';

const FilterAccordion = ({ title, children }) => {
  return (
    <Accordion
      disableGutters
      sx={{
        boxShadow: 'none', // Retirer l'ombre
        '&:before': {
          display: 'none', // Retirer la ligne au-dessus de l'accordéon
        },
        '& .MuiAccordionSummary-root': {
          padding: 0, // Retirer le padding de la summary
        },
        '& .MuiAccordionDetails-root': {
          padding: 0, // Retirer le padding des détails
          transition: 'none', // Désactiver l'animation de la hauteur
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography component="span" style={{fontFamily: 'Montserrat', color: '#013D51'}}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 0 }}>
        {children} 
      </AccordionDetails>
    </Accordion>
  );
};

export default FilterAccordion;
